"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateUserInfo = exports.refreshToken = exports.updateLanguage = exports.getUserFeatures = exports.getUserInfo = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const errorHandling_1 = require("../../utils/errorHandling");
const currentActionTypes = require("../../actionTypes/auth/current");
const loginActionTypes = require("../../actionTypes/auth/login");
const actions = require("../../actions/auth/current");
// Get user info such as email, name and stuff
function getUserInfo(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === currentActionTypes.GET_USERINFO_REQUEST ||
        action.type === loginActionTypes.LOGIN_SUCCESS), (0, operators_1.mergeMap)(() => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/auth/user/info`
    }).pipe((0, operators_1.mergeMap)(({ response }) => (0, rxjs_1.of)(actions.getUserinfoSuccessAction(response))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(actions.getUserinfoFailureAction((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.getUserInfo = getUserInfo;
function getUserFeatures(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === currentActionTypes.FETCH_USER_FEATURES_REQUEST), (0, operators_1.mergeMap)(() => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/auth/user/features`
    }).pipe((0, operators_1.mergeMap)(({ response }) => (0, rxjs_1.of)(actions.fetchUserFeaturesSuccess(response))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(actions.fetchUserFeaturesFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.getUserFeatures = getUserFeatures;
function updateLanguage(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === currentActionTypes.UPDATE_USER_LANGUAGE), (0, operators_1.mergeMap)(({ payload }) => {
        const id = store.value.auth.current.user.fold(null, (user) => user.id);
        if (id === null) {
            return (0, rxjs_1.of)(actions.updateUserLanguageFailure({ type: 'NOT_MODIFIED' }));
        }
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'PATCH',
            body: { language: payload },
            url: `${baseUrl}api/auth/user/${id}/language`
        }).pipe((0, operators_1.mergeMap)(({ response }) => {
            const validate = t
                .interface({
                message: t.string
            })
                .decode(response);
            const act = validate.fold((e) => actions.updateUserLanguageFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)), (c) => {
                return actions.updateUserLanguageSuccess(c.message);
            });
            return (0, rxjs_1.of)(act);
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(actions.updateUserLanguageFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))));
    }));
}
exports.updateLanguage = updateLanguage;
function refreshToken(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === currentActionTypes.REFRESH_TOKEN_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        url: `${baseUrl}api/auth/refresh-token`,
        body: {
            token: store.value.auth.current.token
        }
    }).pipe((0, operators_1.mergeMap)(({ response }) => (0, rxjs_1.of)(actions.refreshTokenSuccessAction(response.token))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(actions.refreshTokenFailureAction((0, errorHandling_1.parseAjaxErrorResponse)(error)))), (0, operators_1.takeUntil)(action$.pipe((0, operators_1.filter)((action) => action.type === loginActionTypes.LOGOUT))))));
}
exports.refreshToken = refreshToken;
function updateUserInfo(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === currentActionTypes.UPDATE_USER_INFO_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'PATCH',
        url: `${baseUrl}api/auth/user/info`,
        body: action.payload
    }).pipe((0, operators_1.mergeMap)(({ response }) => (0, rxjs_1.of)(actions.updateUserInfoSuccessAction(response))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(actions.updateUserInfoFailureAction((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.updateUserInfo = updateUserInfo;
//# sourceMappingURL=current.js.map